import { render, staticRenderFns } from "./procedure.vue?vue&type=template&id=08d6f754&scoped=true&"
import script from "./procedure.vue?vue&type=script&lang=js&"
export * from "./procedure.vue?vue&type=script&lang=js&"
import style0 from "./procedure.vue?vue&type=style&index=0&id=08d6f754&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d6f754",
  null
  
)

export default component.exports